import { fromJS, List, Map } from 'immutable';
// import { ProductRecord, PackageRecord } from './../Record/Products';
const NAME_SPACE = 'E/CA/';
const initialState = Map({
  'loading': false,
  'data': List([]),
  'pageSize': 0,
  'currentPage': 0,
  'count': 0,
});

const item = (state, action) => {
  switch (action.type) {
    case NAME_SPACE + 'RECEIVE_INITIALSTATE':
      return initialState;
    case NAME_SPACE + 'RECEIVE_BILL_COLLECTION':
      return fromJS(action.payload.bill);
    case NAME_SPACE + 'V_LOADING':
      return state.update('loading', loading => action.payload.state);
    default:
      return state;
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case NAME_SPACE + 'RECEIVE_INITIALSTATE':
      return item(undefined, action);
    case NAME_SPACE + 'RECEIVE_BILL_COLLECTION':
      return item(state, action);
    case NAME_SPACE + 'V_LOADING':
      return item(state, action);
    default:
      return state;
  }
};